export default function yearsFilter(value) {
  const year = parseInt(value)
  return year % 10 > 1 &&
    year % 10 < 5 &&
    year !== 12 &&
    year !== 13 &&
    year !== 14
    ? `${year} lata`
    : year === 1
    ? `${year} rok`
    : `${year} lat`
}
